import { Modal } from ".";
import { Button, DeleteButton } from "./Button";

interface IConfirmationPopupProps {
  showModal: boolean;
  setShowModal: Function;
  confirmAction: () => void;
  children?: React.ReactNode | string;
}

const ConfirmationPopup = ({
  confirmAction,
  showModal,
  setShowModal,
  children,
}: IConfirmationPopupProps) => {
  return (
    <>
      <Modal showModal={showModal} setShowExternal={setShowModal}>
        <Modal.Display
          useCloseBtn={false}
          tailwindWidth="w-auto"
          tailwindHeight="h-auto"
        >
          <Modal.Body>
            <div className="bg-white px-6 py-4 flex flex-col gap-8 justify-between rounded-md text-sm">
              <div className="flex-grow grid place-content-center py-2">
                {children}
              </div>
              <div className="flex gap-4 justify-center">
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    setShowModal(false);
                  }}
                >
                  Cancel
                </Button>
                <DeleteButton
                  onClick={(e) => {
                    e.preventDefault();
                    confirmAction();
                  }}
                />
              </div>
            </div>
          </Modal.Body>
        </Modal.Display>
      </Modal>
    </>
  );
};

const DeletePopup = ({
  children,
  ...props
}: IConfirmationPopupProps & { children?: string | React.ReactNode }) => (
  <ConfirmationPopup {...props}>
    {children || <>Are you sure you want to delete this item?</>}
  </ConfirmationPopup>
);

export { ConfirmationPopup, DeletePopup };
